
import { EntityType } from '@frontend/common';
import { CostCenterClient } from '@frontend/cost-center/api';
import { useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useCostCenter:request': CustomEvent<string>;
    }
}

const REQUEST_COST_CENTER_EVENT = 'useCostCenter:request';
const STORAGE_KEY = 'CC_REQ';

export function costCenterRequest(costCenterId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_COST_CENTER_EVENT, { detail: costCenterId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function CostCenterResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_COST_CENTER_EVENT, EntityType.COST_CENTER, (ids) => CostCenterClient.resolveCostCenters(ids), props.dispatch);
    return <></>;
}
